import { useState } from "react";

import type { PaginationArgs } from "api/schemas/common";

export type PaginationModel = {
  page: number;
  pageSize: number;
};
export const paginationModel = { page: 0, pageSize: 25 };

export const usePagination = (defaultPagination?: PaginationModel) => {
  const [pagination, setPagination] = useState<PaginationArgs>({
    limit: defaultPagination?.pageSize || paginationModel.pageSize,
    page: defaultPagination?.page || paginationModel.page,
  });

  return { pagination, setPagination };
};
